import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Element UI 按需引入（常用组件，按需扩展）
import {
  Button,
  Input,
  InputNumber,
  Form,
  FormItem,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message,
  MessageBox,
  Loading,
  Pagination,
  Table,
  TableColumn,
  Select,
  Option,
  Tag,
  Card,
  Container,
  Header,
  Main,
  Footer,
  Row,
  Col,
  Divider,
  Slider,
  Upload,
  Radio,
  RadioGroup
} from 'element-ui'

Vue.use(Button)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tag)
Vue.use(Card)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Divider)
Vue.use(Slider)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)

Vue.use(Loading.directive)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$loading = Loading.service

// 全局样式
import '@/assets/styles/index.scss'

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
